import Api from "../axios"

export const getManualList= async (date)=>{
    return await Api.get(`/manual_list?date=${date}`)
}